import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router'

import { isLoggedIn } from '../../utils/auth'
import '../styles/style.css';

import logo from '../../assets/images/logo-blanc.png'

import picto1 from '../../assets/images/picto1.png'
import picto2 from '../../assets/images/picto2.png'
import picto3 from '../../assets/images/picto3.png'
import picto4 from '../../assets/images/picto4.png'
import picto5 from '../../assets/images/picto5.png'
import picto6 from '../../assets/images/picto6.png'

import Footer from '../../core/components/FooterComponent';

class Home extends Component {
    constructor(props) {
        super(props);
        this.state={
            logged:false
        }
    }


    componentDidMount() {

        if(isLoggedIn()){
          this.setState({logged:true})
        }

    }

   render() {

        return (
            <div className="page-home">

                <div className="header" >
                    <Container >
                      <Row>
                        <Col>
                           <Link to="/"><img alt="logo" src={logo} className="logo" /></Link>
                        </Col>
                        <Col className="login-bloc">
                              {this.state.logged &&
                                <Link to="/login"><Button className="login">Mon compte</Button></Link>
                              }
                             {!this.state.logged &&
                                <Link to="/login"><Button className="login">Se connecter</Button></Link>
                              }
                        </Col>
                      </Row>
                      <Row>
                        <Col className="center">
                          <h1 className="h1">
                            Rejoindre notre <br/> réseau de prestataires
                          </h1>
                        </Col>
                      </Row>
                      <Row >
                        <Col className="center">
                          <div className="line"></div>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="center">
                          <h2 className="h2">
                            15 ans d’expérience <br/> 1 million de clients en France
                          </h2>
                        </Col>
                      </Row>
                       <Row>
                        <Col className="center">
                             <Link to="/register">
                                <Button className="btn-green register">Remplir le formulaire en ligne</Button>
                             </Link>
                        </Col>
                      </Row>
                    </Container>
                </div>

                <Container>
                    {/* <div className="description">
                      <Row className="description-container">
                          <Col className="bloc" xs="12" sm="4">
                              <h3>
                                  <span>3000 professionnels</span> <br/> dans toute la France
                              </h3>
                              <p>
                                HomeServe dispose d'un réseau de 3 000 professionnels, spécialisés dans les domaines de la plomberie, de l’assainissement, du chauffage, et de l'électricité
                              </p>
                          </Col>
                          <Col className="bloc" xs="12" sm="4">
                              <h3>
                                  Un réseau de qualité <br/> <span>et de proximité</span>
                              </h3>
                              <p>
                                Le réseau HomeServe est constitué d’entreprises locales réparties partout en France afin d’assurer des interventions rapides à nos clients
                              </p>
                          </Col>
                          <Col className="bloc" xs="12" sm="4">
                              <h3>
                                  <span>La charte de qualité</span> <br/> HomeServe
                              </h3>
                              <p>
                              Nos prestataires s’engagent à travers la signature d’une charte de qualité HomeServe à délivrer à nos clients le meilleur service d’assistance pour leur maison
                              </p>
                          </Col>
                      </Row>
                  </div>

                     <div className="cadre nodisplay">
                      <Row className="cadre-container">

                          <Col className="nopadding">
                            <h3>
                                Un réseau national de prestataires <span>disponibles et performants. </span>
                            </h3>
                            <p>
                              Pionnier et leader de son marché, HomeServe  met en relation les propriétaires ou locataires avec un professionnel proche de chez eux.
                            </p>
                          </Col>
                      </Row>
                  </div>

                  <div className="datas">
                      <Row className="datas-container">
                          <Col className="nopadding center">
                            <h3>
                              HomeServe réalise <span>depuis 15 ans en France</span> des interventions d’installation, réparation, dépannage.
                            </h3>
                            <p>
                                HomeServe est une société de services qui réalise depuis 15 ans pour les foyers français des interventions d’assistance (installation, réparation, dépannage) dans les domaines de la plomberie, du chauffage, de l’électricité, de l’électroménager et des objets connectés.
                            </p>
                          </Col>
                      </Row>

                      <Row className="datas-container datas-container-list line-1">
                          <Col className="center" xs="12" sm="4">
                              <img alt="logo" src={picto1} />
                              <h4>
                                  <span>3000 professionnels</span> dans toute la France
                              </h4>
                          </Col>
                          <Col className="center middle" xs="12" sm="4">
                              <img alt="logo" src={picto2} />
                              <h4>
                                  <span>Plus de 120 000 interventions</span> réalisées en 2016
                              </h4>
                          </Col>
                          <Col className="center" xs="12" sm="4">
                              <img alt="logo" src={picto3} />
                              <h4>
                                  <span>1 Million</span> de clients 96% de satisfaction*
                              </h4>
                          </Col>
                      </Row>

                      <Row className="datas-container datas-container-list line-2">
                          <Col className="center" xs="12" sm="4">
                              <img alt="logo" src={picto4} />
                              <h4>
                                  <span>15 ans d’expérience</span> en France
                              </h4>
                          </Col>
                          <Col className="center middle" xs="12" sm="4">
                              <img alt="logo" src={picto5} />
                              <h4>
                                  <span>450 collaborateurs</span> en France
                              </h4>
                          </Col>
                          <Col className="center" xs="12" sm="4">
                              <img alt="logo" src={picto6} />
                              <h4>
                                  <span>2,5 millions</span> de contrats d’assistance
                              </h4>
                          </Col>
                      </Row>
                  </div>*/}

              </Container>

              <Footer/>

            </div>
        )
    }
}

export default Home



// WEBPACK FOOTER //
// ./src/home/components/Home.js